// @flow

import VerticalStepProgressBar from './VerticalStepProgressBar';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

export default compose(injectIntl)(VerticalStepProgressBar);



// WEBPACK FOOTER //
// ./src/components/molecules/VerticalStepProgressBar/VerticalStepProgressBarContainer.js